import React from 'react';
import { Layout } from 'fronton-react';
import { Section } from '../section';
import { SectionSubTitle } from '../section-subtitle';
import { Typography } from '../typography';
import {
  reviewsDescription,
  reviewsSection,
  reviewsSectionTitle,
  reviewsTitle,
} from './reviews-section-styles';

type ReviewsSectionProp = {
  benefits: React.ReactNode;
  description: string;
  title: string | React.ReactNode;
  review: React.ReactNode;
};

export const ReviewsSection: React.FC<ReviewsSectionProp> = ({ benefits, description, review, title }) => (
  <Section className={reviewsSection}>
    <Layout>
      <SectionSubTitle className={reviewsSectionTitle} margin="l" color="text-invert">
        {title}
      </SectionSubTitle>
      {benefits}
      <SectionSubTitle className={reviewsTitle} margin="s" color="text-invert">
        Отзывы клиентов
      </SectionSubTitle>
      <Typography className={reviewsDescription} variant="l" size="body_long" color="text-invert">
        {description}
      </Typography>
      {review}
    </Layout>
  </Section>
);
